import { createFileRoute } from "@tanstack/react-router";
import { useGetQuizPlayerQuestionnairePage } from "$/modules/quiz-player/hooks/useGetQuizPlayerQuestionnairePage";

export const Route = createFileRoute(
  "/$locale/quiz-player/$projectId/questionnaires/",
)({
  component: QuestionnairePage,
});

function QuestionnairePage() {
  return useGetQuizPlayerQuestionnairePage();
}
